<template>
    <div class="sidebar-container" :class="{'has-logo':showLogo}">
        <logo v-if="showLogo" :collapse="isCollapse"/>
            <el-menu
                class="menus"
                :default-active="activeMenu"
                :collapse="isCollapse"
                :router="true"
                :background-color="settings.sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground"
                :text-color="settings.sideTheme === 'theme-dark' ? variables.menuColor : variables.menuLightColor"
                :active-text-color="settings.theme"
                :collapse-transition="false"
                mode="vertical"
            >
            <SidebarMenu :collapse="isCollapse" class="el-menu-vertical-dem" :menuList="sidebarRouters"></SidebarMenu>
        </el-menu>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import Logo from "./Logo";
import SidebarMenu from "@/components/SidebarMenu.vue"
import variables from "@/styles/variables.module.scss";

export default {
    name: "SideBar",
    components: {
        // SidebarItem,
        SidebarMenu,
        Logo
    },
    computed: {
        ...mapState(["settings"]),
        ...mapGetters(["sidebarRouters", "sidebar"]),
        activeMenu() {
            const route = this.$route;
            const {meta, path} = route;
            // if set path, the sidebar will highlight the path you set
            if (meta.activeMenu) {
                return meta.activeMenu;
            }
            return path;
        },
        showLogo() {
            return true;
        },
        variables() {
            return variables;
        },
        isCollapse() {
            return !this.sidebar.opened;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.module.scss";

.sidebar-container {
    /* 确保菜单项可点击区域完整 */
    .el-menu-item, .el-submenu__title {
        user-select: none;
        -webkit-tap-highlight-color: transparent;
    }

    /* 移除可能干扰点击的伪元素 */
    .el-menu-item::after, .el-submenu__title::after {
        content: none !important;
    }

    .menus {
        flex: 1;
        height: 100%;
        overflow: auto;
    }

    .el-menu {
        &::-webkit-scrollbar {
            display: none; /* Chrome/Safari/Edge */
            width: 0; /* 兼容部分版本 */
            height: 0;
            background: transparent; /* 可选：透明化 */
        }
    }
}

.el-menu--popup {
    padding: 10px 0;
    border-radius: 6px !important;
}
</style>
